export default {
    TYPE_APPOINTMENT: 'appointment',
    TYPE_DONE_APPOINTMENT: 'done_appointment',
    TYPE_WALKIN: 'walkin'
  }
  